import { useRef as o, useEffect as n } from "react";
const c = (t, r) => {
  const e = o(!1);
  n(() => {
    e.current || !t || (e.current = !0, r());
  }, [t]);
};
export {
  c as useScrollActiveItemIntoViewOnMount
};
